export function normalizeBonificacion(raw) {
  if (!raw) return null;

  const fechaGeneracion =
    raw.fecha_generacion ||
    raw.fechaGeneracion ||
    raw.created_at ||
    raw.createdAt ||
    null;

  return {
    id: raw.id,
    matriculaId: raw.matricula_id ?? null,
    referente: raw.referente || null,
    referido: raw.referido || null,
    monto: Number(raw.monto ?? 0),
    descuento: Number(raw.descuento ?? 0),
    montoNeto: raw.monto_neto != null ? Number(raw.monto_neto) : null,
    cargoDescuentoId: raw.cargo_descuento_id ?? null,
    cargoDescuentoConcepto: raw.cargo_descuento_concepto ?? null,
    cargoDescuentoMonto: raw.cargo_descuento_monto != null ? Number(raw.cargo_descuento_monto) : null,
    observacionDescuento: raw.observacion_descuento ?? null,
    estado: raw.estado || null,
    tipo: raw.tipo || 'cobrada',
    pagoAplicadoId: raw.pago_aplicado_id ?? null,
    motivo: raw.motivo || null,
    fechaGeneracion,
    createdAt: raw.created_at ?? raw.createdAt ?? null,
  };
}
